import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function downloadPrintableClassList(rows, selectedYear) {
  const header = [
    "ID",
    "Surname",
    "Forename",
    "Age",
    "Level",
    "Gender",
    "Nationality",
    "Class",
    "Teacher",
  ];

  const csvRows = rows.map((s) => [
    s.studentId,
    s.student_surname,
    s.student_name,
    s.student_age,
    s.english_level,
    s.student_gender,
    s.student_nationality,
    s.group_name || "None",
    s.adult_full_name || "None",
  ]);

  const csvContent = [header, ...csvRows]
    .map((row) => row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8",
  });

  saveAs(blob, `classlist_${selectedYear}.csv`);
}

export function exportClassListPDF(rows, selectedYear, selectedCampus) {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.text(`Class List - ${selectedCampus || "All Campuses"}`, 14, 20);

  const grouped = rows.reduce((acc, student) => {
    const group = student.group_name || "None";
    if (!acc[group]) acc[group] = [];
    acc[group].push(student);
    return acc;
  }, {});

  Object.entries(grouped).forEach(([groupName, students], index) => {
    if (index > 0) {
      doc.addPage();
    }

    const titleY = index === 0 ? 30 : 20;

    doc.setFontSize(14);
    doc.text(`Class: ${groupName}`, 14, titleY);

    autoTable(doc, {
      startY: titleY + 10,
      head: [[
        "Idx",
        "Surname",
        "Forename",
        "Age",
        "Level",
        "Gender",
        "Nationality",
        "Class",
        "Teacher",
      ]],
      body: students.map((s, i) => [
        i + 1,
        s.student_surname,
        s.student_name,
        s.student_age,
        s.english_level,
        s.student_gender,
        s.student_nationality,
        s.group_name || "None",
        s.adult_full_name || "None",
      ]),
      theme: "grid",
      headStyles: { fillColor: [22, 160, 133] },
      margin: { top: 10 },
    });
  });

  doc.save(`classlist_${selectedYear}_${selectedCampus || "all"}.pdf`);
}